import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
export const CurrentNetworkContext = createContext({
    currentNetwork: {},
    updateCurrentNetwork: () => {
        throw new Error('updateCurrentNetwork is not implemented');
    },
});
export const useCurrentNetworkContext = () => useContext(CurrentNetworkContext);
export const CurrentNetworkProvider = ({ children, currentNetwork: initialCurrentNetwork, }) => {
    const [currentNetwork, setCurrentNetwork] = useState(() => initialCurrentNetwork);
    const value = useMemo(() => ({
        currentNetwork,
        updateCurrentNetwork: (network) => setCurrentNetwork((prev) => (Object.assign(Object.assign({}, prev), network))),
    }), [currentNetwork]);
    return (_jsx(CurrentNetworkContext.Provider, { value: value, children: children }));
};
//# sourceMappingURL=CurrentNetworkContext.js.map